import { render } from "./breadcrumb-clinic.vue?vue&type=template&id=6e0d7d88"
import script from "./breadcrumb-clinic.vue?vue&type=script&lang=js"
export * from "./breadcrumb-clinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__